<template>
  <div id="Banks">
    <headNav>
      <div slot="headNavText">{{$t('message.info_lxwm_server')}}</div>
    </headNav>
    <div style="width: 100%;margin: 10px auto 3px;padding-left: 20px;padding-top: 1.5rem">{{$t('message.ser_qxzkf')}}
    </div>
    <!--    选择客服-->
    <van-popover
      v-model="showPopover"
      trigger="click"
      :actions="actions"
      @select="onSelect"
      placement="bottom"
    >
      <template #reference>
        <div class="my">
          <div style="display: flex;align-items: center"><img :src="default_service_img" alt=""
                                                              style="width: 50px;height: 50px;margin-right: 8px">{{default_service}}
          </div>
          <div>
            <van-icon name="arrow"/>
          </div>
        </div>
      </template>
    </van-popover>

    <div class="items">
      <h3>{{$t('message.ser_gfgh')}}</h3>
      <p>{{$t('message.ser_nkydj')}}</p>
      <div style="font-size: 20px;font-weight: 600"><a :href="'tel:'+default_tel">{{default_tel}}</a></div>
    </div>
    <div class="items">
      <h3>{{$t('message.ser_zalo')}}</h3>
      <p>{{$t('message.ser_addZalo')}}</p>
      <div style="font-size: 20px;font-weight: 600">{{default_zalo}}</div>
    </div>


  </div>
</template>

<script>
  import {sassService} from '../../ports/port';
  import headNav from "../HeadNav/headNav";

  export default {
    name: "banks",
    data() {
      return {
        tk: JSON.parse(localStorage.getItem("tokenAll")),
        showPopover: false,
        actions: [],
        serList: [],//客服列表
        default_service: '',
        default_service_img: '',
        default_tel: '',
        default_zalo: '',
        coin: this.$coin,
      }

    },
    components: {
      headNav
    },
    created() {
      this.$router.replace({
        path: this.$route.path, // 保留当前路径
        query: {
          ...this.$route.query, // 保留已有的 query 参数
          chntoken: sessionStorage.getItem('chntoken')  // 添加新的参数
        }
      });
      sassService({userid: this.tk.userid})
        .then((res) => {
          if (res.data.code == 200) {
            this.serList = res.data.data;
            res.data.data.map((elem, index) => {
              this.actions.push({text: elem.name})
            });
            this.default_service = this.actions[0].text;
            this.default_service_img = this.serList[0].image;
            this.default_tel = this.serList[0].official_phone;
            this.default_zalo = this.serList[0].official_zalo;
          } else {
            this.$notify({type: 'danger', message: res.data.msg});
          }

        })
        .catch(err => {
          this.$store.commit('edit', false);//关闭全局的loading
          if (err.toString().indexOf('timeout') != -1) {
            this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
          }
        })
    },
    methods: {
      goAddBanks() {
        this.$router.push('/editInfo/setBanks')
      },
      selectService() {
        this.showService = true;
      },
      onSelect(action, index) {
        this.default_service = action.text;
        this.default_service_img = this.serList[index].image;
        this.default_tel = this.serList[index].official_phone;
        this.default_zalo = this.serList[index].official_zalo;
      },
    }
  }
</script>

<style scoped lang="scss">
  #Banks {
    background: #F2F4FB;
    min-height: 100vh;

    .title {
      text-align: center;
      background: white;
      font-size: 16px;
      padding: 10px 0;
      border-bottom: 1px solid #F2F4FB;
      position: relative;

      i {
        position: absolute;
        left: 20px;
        font-size: 20px;
      }
    }

    .items {
      background: #fff;
      width: 95%;
      margin: 0 auto 15px;
      padding: 15px;
      box-sizing: border-box;
      border-radius: 10px;

      > div {
        /*padding: 15px 20px;*/
        /*border-bottom: 1px solid #f3f1f1;*/
      }
    }

    .my {
      padding: 10px 20px;
      background: #fff;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  /deep/ .van-popover__wrapper {
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/pages/home/service.vue